import { Box, ButtonBase, makeStyles, Typography } from "@material-ui/core";
import PlayArrow from "@material-ui/icons/PlayArrow";
import React from "react";
import { useHistory } from "react-router";

import { WebinarSummary } from "@/api/generated";
import { homeCardStyle, HomeRail, HomeSection } from "@/components/home/HomeSection";
import { Loading } from "@/components/Loading";
import { layoutTokens, semanticColors, textStyles } from "@/designTokens";
import { useDevice } from "@/hooks/useDevice";

const useStyles = makeStyles({
  card: {
    ...homeCardStyle,
    width: 240,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    overflow: "hidden",
    textAlign: "left",
  },
  pcCard: { width: 320 },
  visual: {
    position: "relative",
    width: "100%",
    aspectRatio: "16 / 9",
    backgroundColor: semanticColors["field/bg"],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  pcVisual: { backgroundColor: semanticColors["surface/inverse"] },
  thumbnail: { position: "absolute", width: "100%", height: "100%", objectFit: "cover" },
  play: {
    position: "relative",
    width: 40,
    height: 40,
    borderRadius: layoutTokens.radius.full,
    backgroundColor: semanticColors["surface/card"],
    color: semanticColors["surface/inverse"],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  body: { padding: layoutTokens.space[16], minHeight: 68, width: "100%" },
  title: {
    ...textStyles["SP/Heading/H4"],
    color: semanticColors["text/primary"],
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    overflowWrap: "anywhere",
  },
});

export const PremiumWebinarSection: React.FC<{ webinars: WebinarSummary[]; loading: boolean }> = ({
  webinars,
  loading,
}) => {
  const classes = useStyles();
  const { isMobile } = useDevice();
  const history = useHistory();
  return (
    <HomeSection title="プロパリー限定動画" onViewAll={() => history.push("/webinars")}>
      {loading ? (
        <Loading />
      ) : (
        <HomeRail label="プロパリー限定動画">
          {webinars.slice(0, 10).map((webinar) => (
            <ButtonBase
              key={webinar.id}
              className={`${classes.card} ${isMobile ? "" : classes.pcCard}`}
              disabled={!webinar.id}
              onClick={() => webinar.id && history.push(`/webinars/${webinar.id}`)}
            >
              <Box className={`${classes.visual} ${isMobile ? "" : classes.pcVisual}`}>
                {webinar.thumbnail_url && (
                  <img className={classes.thumbnail} src={webinar.thumbnail_url} alt="" loading="lazy" />
                )}
                <Box className={classes.play}>
                  <PlayArrow />
                </Box>
              </Box>
              <Box className={classes.body}>
                <Typography className={classes.title}>{webinar.title}</Typography>
              </Box>
            </ButtonBase>
          ))}
        </HomeRail>
      )}
    </HomeSection>
  );
};
